/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import BaseCom from "./BaseCom";
import Card from "./Card";
import FormInput from "./FormInput";
import Person from "./Person";
import UploadImage from "./UploadImage";


export default class Provider extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            item: props.item,
            edit: true
        };
    }

    render() {
        return <>
            <div className="row">
                <div className="col-sm-9">
                    <Person item={this.state.item} title="Provider Info" requestAddress requireOnlyBasic />
                </div>
                <div className="col-sm-3">
                    <Card title="Photo">
                        <UploadImage fileIdent={this.state.item.photoIdent} className="text-center" onChange={photo => this.props.item.photoIdent = photo.fileIdent } />
                    </Card>
                </div>
            </div>
            <Card title="Identification">
                <FormInput model={this.state.item} name="npi" label="NPI" type="text" />
            </Card>
            <Card title="Contact Information">
                <div className="row">
                    <div className="col">
                        <FormInput model={this.state.item} name="phone" label="Phone" type="text" />
                    </div>
                    <div className="col">
                        <FormInput model={this.state.item} name="fax" label="Fax" type="text" />
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <FormInput model={this.state.item} name="contactName" label="Contact Name" type="text" />
                    </div>
                    <div className="col">
                        <FormInput model={this.state.item} name="contactPhone" label="Contact Phone" type="text" />
                    </div>
                    <div className="col">
                        <FormInput model={this.state.item} name="medicareContactName" label="Medicare Contact Name" type="text" />
                    </div>
                </div>
            </Card>
            <Card title="More Information">
                <div className="row">
                    <div className="col">
                        <FormInput model={this.state.item} name="tin" label="TIN" type="text" />
                    </div>
                    <div className="col">
                        <FormInput model={this.state.item} name="ptan" label="PTAN" type="text" />
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <FormInput model={this.state.item} name="specialty" label="Specialty" type="text" />
                    </div>
                    <div className="col">
                        <FormInput model={this.state.item} name="siteName" label="Site Name" type="text" />
                    </div>
                </div>
            </Card>
        </>;
    }
}